// Search contract for the member-user handler that backs the site owner picker. Mirrors the
// server-side constants in server/src/Modules/AGWA.Auth/Search/MemberUserSearchHandler.cs
// (Tag / ContextKeyLoginGroupId). These strings are part of the search contract - drift from the
// server would silently no-op the scoping and offer an empty (or wrong) member list.

/** Server-side handler tag; passed to agwa-search-picker/agwa-search-dialog as `tag`. */
export const MEMBER_USER_SEARCH_TAG = 'member-user';

export const MEMBER_USER_SEARCH_CONTEXT = {
  /** Scopes the picker to the people of this LoginGroup (the site's group) who have not been deleted, blocked ones included (D-174). Required - absent/invalid yields an empty list. */
  loginGroupId: 'loginGroupId',
} as const;
